module.exports = __webpack_public_path__ + "img/461.74c03184.png";